import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { FaKey, FaBook } from "react-icons/fa";
import { BsChatFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.png";
import "../assets/css/SidebarModern.css";

const { Sider } = Layout;

// ============ ÍCONES ============
const IconDashboard = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
  </svg>
);
const IconPausa = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/>
  </svg>
);
const IconEscala = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconTurno = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
  </svg>
);
const IconLAEE = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6 6l.96-.96a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 21.5 16z"/>
  </svg>
);
const IconMovicel = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
    <line x1="12" y1="18" x2="12.01" y2="18"/>
  </svg>
);
const IconIPU = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);
const IconChat = <BsChatFill size={16} />;
const IconBiblioteca = <FaBook size={16} />;

// ============ MENU OK KONTACT ============

const buildOkKontactItems = (perfil, aprovarSala) => {
  const isOperador = perfil === "OPERADOR";
  const isAdmin    = perfil === "ADMIN";

  return [
    { key: "/dashboard",   label: "Dashboard",        icon: IconDashboard },
    { key: "/turno",       label: "Turno",             icon: IconTurno },
    {
      key: "laee",
      label: "ZERO SOFT",
      icon: IconLAEE,
      children: [
        { key: "/chamada_laee",   label: "Chamada" },
        ...(!isOperador ? [{ key: "/relatorio_laee", label: "Relatório" }] : []),
      ],
    },
    {
      key: "movicel",
      label: "PT ANGOLA",
      icon: IconMovicel,
      children: [
        { key: "/chamada_movicel", label: "Chamada" },
      ],
    },
    {
      key: "ipu",
      label: "MIL VENDAS",
      icon: IconIPU,
      children: [
        { key: "/chamada_ipu",   label: "Chamada" },
        ...(!isOperador ? [{ key: "/relatorio_ipu", label: "Relatório" }] : []),
      ],
    },
    // Pausas aparece para TODOS
    { key: "/pausas",      label: "Pausas",            icon: IconPausa },
    { key: "/ticket_movicel",      label: "Ticket",            icon: IconDashboard },
    { key: "/escala",      label: "Turno de trabalho", icon: IconEscala },
    { key: "/chat",        label: "Next Chat",         icon: IconChat },
    // Gestão de Pausas só para ADMIN
    ...(isAdmin ? [{ key: "/gestao-pausa", label: "Gestão de Pausas", icon: IconPausa }] : []),
    { key: "/biblioteca",  label: "Biblioteca",        icon: IconBiblioteca },
  ];
};

// ============ MENU POR PERFIL ============

const getMenuByPerfil = (perfil, aprovarSala) => {
  return buildOkKontactItems(perfil, aprovarSala);
};

// ============ COMPONENTE ============

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const [perfil, setPerfil]       = useState(null);
  const [openKeys, setOpenKeys]   = useState([]);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    const userStored = JSON.parse(localStorage.getItem("user"));
    if (!userStored) return;

    const perfilNormalizado = userStored.perfil?.trim()?.toUpperCase();
    const aprovarSala       = userStored.aprovar_sala === "S";
    setPerfil(perfilNormalizado);

    const menuFinal = getMenuByPerfil(perfilNormalizado, aprovarSala);

    setMenuItems([
      ...menuFinal,
      { type: "divider" },
      {
        key:   "senha",
        icon:  <FaKey />,
        label: "Alterar Senha",
        onClick: () => navigate("/alterar_senha"),
      },
      {
        key:   "logout",
        icon:  <LogoutOutlined />,
        label: "Sair",
        onClick: logout,
      },
    ]);
  }, []);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    const rootSubmenuKeys = ["laee", "movicel", "ipu"];

    if (rootSubmenuKeys.includes(latestOpenKey)) {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      const parentKey = keys.find((key) => rootSubmenuKeys.includes(key));
      setOpenKeys(parentKey ? [parentKey, latestOpenKey].filter(Boolean) : keys);
    }
  };

  return (
    <Sider
      className={`modern-sider ${collapsed ? "collapsed" : ""}`}
      collapsible
      collapsed={collapsed}
      trigger={null}
      width={270}
      collapsedWidth={82}
    >
      <div className="sidebar-logo" onClick={() => navigate("/dashboard")}>
        <img
          src={logo}
          alt="Logo"
          className={`logo-img ${collapsed ? "collapsed" : ""}`}
        />
      </div>

      <Menu
        key={perfil}
        mode="inline"
        className="modern-menu"
        items={menuItems}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        onClick={(item) => {
          if (item.key === "logout" || item.key === "senha") return;
          navigate(item.key);
        }}
      />
    </Sider>
  );
};

export default Sidebar;